import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtworkCollection = (page, pageSize, artistId=null, order=null, search=null) => {
  const params = {
    page,
    page_size: pageSize,
    ordering: order,
    search: search,
  }
  return axios.get(URL_PREFIX + '/artwork-collections/', {
    params
  })
}

export const getArtworkCollectionPublic = (artistId) => {
  return axios.get(URL_PREFIX + '/artwork-collections-public/?artist_id=' + artistId)
}

export const getArtworkCollectionAdmin = (page, pageSize, artistId, order=null, search=null) => {
  const params = {
    page,
    ordering: order,
    search: search,
    page_size: pageSize,
    artist_id: artistId,
    artist: artistId
  }
  return axios.get(URL_PREFIX + '/artwork-collections-admin/', {
    params
  })
}

export const getArtworkCollectionById = (id) => {
  return axios.get(URL_PREFIX + '/artwork-collections/' + id + '/')
}

export const postArtworkCollection = (param) => {
  return axios.post(URL_PREFIX + '/artwork-collections/', param)
}

export const patchArtworkCollection = (id, param) => {
  return axios.patch(URL_PREFIX + '/artwork-collections/' + id + '/', {
    ...param
  })
}

export const deleteArtworkCollection = (id) => {
  return axios.delete(URL_PREFIX + '/artwork-collections/' + id + '/')
}
